import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/ImportEstimation.styled.ts",
    _templateObject2,
    _templateObject3,
    _templateObject4,
    _templateObject5,
    _templateObject6,
    _templateObject7;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { DialogContent } from '@gmini/ui-kit/lib/DialogContent';
import { Paper } from '@gmini/ui-kit/lib/Paper';
import { Backdrop } from '@gmini/ui-kit/lib/Backdrop';
export var Footer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 9px 24px;\n  display: flex;\n"])));
export var FooterActions = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-left: auto;\n  gap: 10px;\n  display: flex;\n"])));
export var Content = styled(DialogContent)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  && {\n    padding: 0px;\n    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.25);\n    clip-path: inset(-60px 0px 0px 0px);\n    position: relative;\n    border-bottom: 1px solid #e5e7f1;\n    margin-top: 18px;\n  }\n"])));
export var SubHeader = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 0 0 0 16px;\n"])));
export var Header = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 18px 24px 13px 24px;\n"])));
export var DialogBody = styled(Paper)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  && {\n    height: 100%;\n\n    max-height: calc(100% - 130px);\n  }\n"])));
export var BackdropComponent = styled(Backdrop)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  && {\n    background-color: rgba(0, 0, 25, 0.5);\n  }\n"])));